var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SideBar',{attrs:{"width":_vm.getSideBarWidth(),"isMobile":_vm.isMobile},scopedSlots:_vm._u([{key:"side-bar-activator",fn:function(){return [_c('Activator',{key:`side_bar_activator>`,staticClass:"self-centered cursor-e-resize",nativeOn:{"mousedown":function($event){_vm.location === 'HistProjectTaktPlan' ? _vm.$router.push({name: 'HistProjectTaktPlan'}) :_vm.$router.push({name: 'ProjectTaktPlan'})}}})]},proxy:true},{key:"content",fn:function(){return [_c('WaggonInfo',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('draggable',{key:`workpackages${_vm.twaggon_id}`,staticClass:"display-flex",style:(`width: ${_vm.isEditMode?'calc(100% - 32px)':'100%'}`),attrs:{"disabled":!_vm.isEditMode,"animation":"300","forceFallback":"true","fallbackOnBody":"true","value":_vm.waggon.tworkpackages},on:{"end":function($event){($event.newIndex - $event.oldIndex !== 0)?_vm.requestSnackbarUpdatePosition({
            url: [
              {projects: _vm.project_id},
              {trains: _vm.train_id},
              {taktareas: _vm.taktarea_id},
              {twaggons: _vm.twaggon_id},
              {tworkpackages: _vm.waggon.tworkpackages[$event.oldIndex]}
            ],
            update: {
              position: $event.newIndex - $event.oldIndex
            }
          }).then((payload) => {
            _vm.updateUObjectPosition(payload)
          }):''}}},_vm._l((_vm.tworkpackages),function(workpackage,index){return _c('WaggonInfoHeader',{key:'header' + workpackage.id,attrs:{"width":_vm.getHeaderWidth(workpackage.id),"textcolor":workpackage.textcolor,"color":workpackage.color,"text":workpackage.id !== _vm.tworkpackage_id?workpackage.token:'',"wp_part":workpackage.id !== _vm.tworkpackage_id?workpackage.workpackage_part:'',"icon":workpackage.id !== _vm.tworkpackage_id? workpackage.icon:'',"cursor":_vm.isEditMode?'grab':''},nativeOn:{"click":function($event){_vm.$router.push({
            name: !_vm.$route.name.includes('TaktPlanAddWorkPackage')?_vm.$route.name:'TaktPlanWorkPackageInfo',
            params: {
              tworkpackage_id: workpackage.id,
              }
            })}}},[(_vm.isEditMode && workpackage.id === _vm.tworkpackage_id)?[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.show_header_options = !_vm.show_header_options}}},[_c('TIcon',{attrs:{"color":workpackage.textcolor,"name":"vertical-dots"}})],1),_c('TransitionAccordion',[(_vm.show_header_options)?_c('PopUpOverlay',{staticStyle:{"z-index":"20"},attrs:{"width":`${2 * 140}px`,"margin":8,"position_css":`
                right: 10px;
                transform: translate(0%, 100%);
              `,"is_no_cancel":true,"z_index":1},on:{"closeOverlay":function($event){_vm.show_header_options = false}},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('div',{staticClass:"workpackage-sidebar-option-buttons"},[_c('ClickablePopUpIcon',{attrs:{"icon":"pencil","color":"var(--primary)","description":"edit"},on:{"selected":function($event){_vm.edit_wp = workpackage, _vm.show_header_options = false}}}),_c('ClickablePopUpIcon',{attrs:{"icon":"copy","color":"var(--primary)","description":"copy"},on:{"selected":function($event){_vm.getNestedWorkPackageCopy(workpackage.id, false, 't').then(work_package => {
                          _vm.updateWBLObject({
                          path: [
                          {workpackage: ''}
                          ],
                          update: work_package
                          }),
                          _vm.$router.push({
                            name: 'TaktPlanWorkPackageCopyWorkPackageEditor',
                            params: { workpackage_id: 'create' }
                          })
                        }), _vm.show_header_options = false}}}),_c('ClickablePopUpIcon',{attrs:{"icon":"copy-extra","color":"var(--primary)","description":"copy incl. steps"},on:{"selected":function($event){_vm.getNestedWorkPackageCopy(workpackage.id, true, 't').then(work_package => {
                          _vm.updateWBLObject({
                          path: [
                          {workpackage: ''}
                          ],
                          update: work_package
                          }),
                          _vm.$router.push({
                            name: 'TaktPlanWorkPackageCopyWorkPackageEditor',
                            params: { workpackage_id: 'create' }
                          })
                        }), _vm.show_header_options = false}}}),(_vm.hasPermission('Taktprint CREATE'))?_c('ClickablePopUpIcon',{attrs:{"icon":"print","color":"var(--primary)","description":"print"},on:{"selected":function($event){return _vm.$router.push({
                            name: 'ProjectWalletPrint'
                          })}}}):_vm._e(),_c('div',{staticClass:"workpackage-sidebar-deletebutton-wrapper"},[_c('StandardDeleteButton',{staticStyle:{"margin-right":"0px !important","margin-top":"2px"},attrs:{"zoom":1.3},on:{"clickDelete":function($event){_vm.requestSnackbarDelete({
                          url: [
                            {projects: _vm.project_id},
                            {trains: _vm.train_id},
                            {taktareas: _vm.taktarea_id},
                            {twaggons: _vm.twaggon_id},
                            {tworkpackages: workpackage.id}
                          ],
                          selector: 'target'
                        }).then((payload) => {
                          _vm.waggon.tworkpackages.length > 1?
                          _vm.$router.push({
                            name: 'TaktPlanWorkPackageInfo',
                            params: {
                              tworkpackage_id: index === _vm.waggon.tworkpackages.length-1?_vm.waggon.tworkpackages[index-1]:_vm.waggon.tworkpackages[index+1],
                            }
                            }).then(() => {
                              _vm.deleteUObject(payload);
                            })
                            :
                            _vm.$router.push({
                              name: 'TaktPlanAddWorkPackage',
                            }).then(() => {
                              _vm.deleteUObject(payload);
                            })
                        })}}}),_c('TText',{staticStyle:{"margin-top":"3px"},attrs:{"value":"delete","size":9,"color":"var(--primary)"}})],1)],1)]},proxy:true}],null,true)}):_vm._e()],1),(false)?[_c('v-btn',{attrs:{"icon":"","color":workpackage.textcolor,"small":""},on:{"click":function($event){_vm.edit_wp = workpackage}}},[_c('v-icon',[_vm._v("edit")])],1),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({attrs:{"icon":"","small":"","color":workpackage.textcolor},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.getNestedWorkPackageCopy(workpackage.id, true, 't').then(work_package => {
                  _vm.updateWBLObject({
                  path: [
                  {workpackage: ''}
                  ],
                  update: work_package
                  }),
                  _vm.$router.push({
                    name: 'TaktPlanWorkPackageCopyWorkPackageEditor',
                    params: { workpackage_id: 'create' }
                  })
                })}}},on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("content_copy")])],1)]}}],null,true)},[_c('span',[_vm._v("Copy to Workbench with Steps")])]),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({attrs:{"icon":"","small":"","color":workpackage.textcolor},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.getNestedWorkPackageCopy(workpackage.id, false, 't').then(work_package => {
                  _vm.updateWBLObject({
                  path: [
                  {workpackage: ''}
                  ],
                  update: work_package
                  }),
                  _vm.$router.push({
                    name: 'TaktPlanWorkPackageCopyWorkPackageEditor',
                    params: { workpackage_id: 'create' }
                  })
                })}}},on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("file_copy")])],1)]}}],null,true)},[_c('span',[_vm._v("Copy to Workbench without Steps")])]),_c('StandardDeleteButton',{attrs:{"zoom":1},on:{"clickDelete":function($event){_vm.requestSnackbarDelete({
              url: [
                {projects: _vm.project_id},
                {trains: _vm.train_id},
                {taktareas: _vm.taktarea_id},
                {twaggons: _vm.twaggon_id},
                {tworkpackages: workpackage.id}
              ],
              selector: 'target'
            }).then((payload) => {
              _vm.waggon.tworkpackages.length > 1?
              _vm.$router.push({
                name: 'TaktPlanWorkPackageInfo',
                params: {
                  tworkpackage_id: index === _vm.waggon.tworkpackages.length-1?_vm.waggon.tworkpackages[index-1]:_vm.waggon.tworkpackages[index+1],
                }
                }).then(() => {
                  _vm.deleteUObject(payload);
                })
                :
                _vm.$router.push({
                  name: 'TaktPlanAddWorkPackage',
                }).then(() => {
                  _vm.deleteUObject(payload);
                })
            })}}})]:_vm._e()]:_vm._e()],2)}),1),(_vm.isEditMode)?_c('WaggonInfoHeaderAdd',{nativeOn:{"click":function($event){return _vm.$router.push({
            name: 'TaktPlanAddWorkPackage'
            })}}}):_vm._e()]},proxy:true},{key:"body",fn:function(){return [_c('router-view')]},proxy:true}])}),(_vm.edit_wp)?_c('EditTWorkPackageDialog',{attrs:{"workpackage":_vm.edit_wp},on:{"closeDialog":function($event){_vm.edit_wp = false},"changeWP":function($event){_vm.changeTWorkPackage({
        project_id: _vm.project_id,
        train_id: _vm.train_id,
        taktarea_id: _vm.taktarea_id,
        twaggon_id: _vm.twaggon_id,
        tworkpackage_id: _vm.edit_wp.id,
        new_wp: $event.new_wp,
        snackbar_call: $event.snackbar_call
      }).then(() => {
        _vm.edit_wp = false
        })}}}):_vm._e()]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }